function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "boldare-boards-board",
  transform: "translate(-840.000000, -107.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(840.000000, 108.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#242424",
  points: "0.7074 18.0538 2.1004 19.4478 18.5524 2.9938 17.1604 1.6008"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(0.000000, 0.154400)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-2",
  stroke: "#242424",
  points: "0.7072 17.8995 17.1602 1.4465 18.5532 2.8395 2.1002 19.2935"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3624,17.2735 C6.0484,17.2735 3.3484,14.5855 3.3484,11.2595 C3.3484,7.9335 6.0364,5.2455 9.3624,5.2455 C12.6874,5.2455 15.3764,7.9335 15.3764,11.2595 C15.3764,14.5855 12.6874,17.2735 9.3624,17.2735 M10.3704,3.3215 L10.3704,2.2555 L12.1774,2.2555 L12.1774,0.2515 L6.3724,0.2515 L6.3724,2.2555 L8.3654,2.2555 L8.3654,3.3215 C3.9734,3.8775 0.8684,7.8875 1.4124,12.2675 C1.9574,16.6475 5.9784,19.7645 10.3584,19.2205 C14.7504,18.6645 17.8564,14.6555 17.3114,10.2745 C16.8594,6.6355 13.9974,3.7735 10.3704,3.3215",
  id: "Fill-4",
  fill: "#242424"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3624,17.2735 C6.0484,17.2735 3.3484,14.5855 3.3484,11.2595 C3.3484,7.9335 6.0364,5.2455 9.3624,5.2455 C12.6874,5.2455 15.3764,7.9335 15.3764,11.2595 C15.3764,14.5855 12.6874,17.2735 9.3624,17.2735 Z M10.3704,3.3215 L10.3704,2.2555 L12.1774,2.2555 L12.1774,0.2515 L6.3724,0.2515 L6.3724,2.2555 L8.3654,2.2555 L8.3654,3.3215 C3.9734,3.8775 0.8684,7.8875 1.4124,12.2675 C1.9574,16.6475 5.9784,19.7645 10.3584,19.2205 C14.7504,18.6645 17.8564,14.6555 17.3114,10.2745 C16.8594,6.6355 13.9974,3.7735 10.3704,3.3215 Z",
  id: "Stroke-6",
  stroke: "#242424",
  strokeWidth: 0.811
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3624,11.1671 L13.9734,11.1671 C13.9734,8.6061 11.9234,6.5201 9.3624,6.4621 L9.3624,11.1671 Z",
  id: "Fill-8",
  fill: "#242424"
})))));

var SvgTimeOffSecond = function SvgTimeOffSecond(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimeOffSecond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time-off-second.ab065c4d.svg";
export { ForwardRef as ReactComponent };